import setSafeFunction from './includes/handler/setsafefunction';
import disableanalytics from './includes/integrations/disableanalytics';
import setAshData from './includes/integrations/lta-ash-data';
import onPageloadGtm from './includes/integrations/lta-onpageload-gtm';
import initLaunchReady from './includes/integrations/lta-onpageload-init';
import ltanalytics from './includes/integrations/ltanalytics-lta-launchstrap';
import referralPixel from './includes/integrations/referral-pixel';

const functionsArray = [disableanalytics, ltanalytics, referralPixel, setAshData, initLaunchReady, onPageloadGtm];

for (const func of functionsArray) {
  setSafeFunction(func)();
}
